export default function ElectricHeater(props: any) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_18_4116)">
                <path
                    d="M27 22.5L27 9.5C27 8.67157 26.3284 8 25.5 8L22.5 8C21.6716 8 21 8.67157 21 9.5L21 22.5C21 23.3284 21.6716 24 22.5 24L25.5 24C26.3284 24 27 23.3284 27 22.5Z"
                    stroke="#757575"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <circle cx="24" cy="12" r="1" transform="rotate(180 24 12)" fill="#757575" />
                <path
                    d="M21 22L21 10C21 8.89543 20.1046 8 19 8C17.8954 8 17 8.89543 17 10L17 22C17 23.1046 17.8954 24 19 24C20.1046 24 21 23.1046 21 22Z"
                    stroke="#757575"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M17 22L17 10C17 8.89543 16.1046 8 15 8C13.8954 8 13 8.89543 13 10L13 22C13 23.1046 13.8954 24 15 24C16.1046 24 17 23.1046 17 22Z"
                    stroke="#757575"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M13 22L13 10C13 8.89543 12.1046 8 11 8C9.89543 8 9 8.89543 9 10L9 22C9 23.1046 9.89543 24 11 24C12.1046 24 13 23.1046 13 22Z"
                    stroke="#757575"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M9 22L9 10C9 8.89543 8.10457 8 7 8C5.89543 8 5 8.89543 5 10L5 22C5 23.1046 5.89543 24 7 24C8.10457 24 9 23.1046 9 22Z"
                    stroke="#757575"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path d="M24 24L24 26.6667" stroke="#757575" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M25 21H23" stroke="#757575" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M25 18H23" stroke="#757575" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7 24L7 26.6667" stroke="#757575" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                    d="M9.90143 4.01725L9.52522 4.51516C9.366 4.72589 9.47491 5.03075 9.7316 5.0929V5.0929C9.99341 5.15628 10.0999 5.47079 9.93049 5.68021L9.51753 6.19067"
                    stroke="#757575"
                    stroke-width="1.2"
                    stroke-linecap="round"
                />
                <path
                    d="M13.9014 4.01725L13.5252 4.51516C13.366 4.72589 13.4749 5.03075 13.7316 5.0929V5.0929C13.9934 5.15628 14.0999 5.47079 13.9305 5.68021L13.5175 6.19067"
                    stroke="#757575"
                    stroke-width="1.2"
                    stroke-linecap="round"
                />
                <path
                    d="M17.9014 4.01725L17.5252 4.51516C17.366 4.72589 17.4749 5.03075 17.7316 5.0929V5.0929C17.9934 5.15628 18.0999 5.47079 17.9305 5.68021L17.5175 6.19067"
                    stroke="#757575"
                    stroke-width="1.2"
                    stroke-linecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_18_4116">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
